module.exports = __webpack_public_path__ + "img/signup_mask.5c4d091e.svg";